import { FC, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';

import qs from 'query-string';
import API from 'core/Api';

import { getUserInfo } from 'utils/auth';
import { getSubdomain } from 'utils/helpers/routing';
import { useActiveClientContext } from 'store/active-client';
import { formatDate } from 'utils/helpers/formatters';
import { buildClientEntity } from 'utils/helpers/client';

import { useLanguageContext } from 'store/language';

import InnerWrapper from 'routes/client/reports/InnerWrapper';
import NotAuthorizedScreen from 'routes/not-authorized';
import ReportForm from './components/ReportForm';

const HealthAndSafetyTrainingReportForm: FC = () => {
  const { client } = useActiveClientContext();
  const { language } = useLanguageContext();

  const methods = useForm();
  const openLinkBtn = useRef<HTMLAnchorElement>(null);
  const isOperator = getSubdomain() === 'operators';
  const isFormActive = getUserInfo().featureHealthAndSafetyTraining;
  const [link, setLink] = useState<string | null>(null);

  const {
    isLoading: isLoadingDropdowns,
    error: errorDropdowns,
    data: dropdowns,
  } = useQuery<any, Error>([buildClientEntity('report-health-and-safety-dropdowns', client)], (): Promise<any> => {
    return API.get('reports/health-and-safety-training/dropdown-options').then(res => {
      return res.data[language || 'bg'];
    });
  });

  const handleSubmitReport = (data: any) => {
    let dateFrom = data.date_from;
    let dateTo = data.date_to;

    const shouldPopulateDates = !!dateFrom || !!dateTo;

    if (shouldPopulateDates) {
      dateFrom = data.date_from && formatDate(data.date_from, 'YYY/mm/dd');
      dateTo = data.date_to ? formatDate(data.date_to, 'YYY/mm/dd') : formatDate(new Date(), 'YYY/mm/dd');

      if (dateFrom) methods.setValue('date_from', new Date(dateFrom));
      if (dateTo) methods.setValue('date_to', new Date(dateTo));
    }

    const formattedData = {
      ...data,
      date_from: dateFrom,
      date_to: dateTo,
      user: data.user?.map((user: any) => user.value),
      group: data.group?.map((group: any) => group.value),
      type: data.type?.map((type: any) => type.value),
    };

    const queryString = qs.stringify(
      {
        ...formattedData,
      },
      { arrayFormat: 'bracket', skipNull: true }
    );
    return API.get(`reports/health-and-safety-training/download?${queryString}`).then(res => {
      setLink(res.data.url);
    });
  };

  useEffect(() => {
    if (link) openLinkBtn?.current?.click();
  }, [link]);

  if (isFormActive || isOperator) {
    return (
      <InnerWrapper
        isLoading={isLoadingDropdowns}
        error={errorDropdowns}
      >
        {dropdowns && (
          <ReportForm
            data={dropdowns}
            methods={methods}
            onSubmit={handleSubmitReport}
          />
        )}
        {link && (
          <Link
            ref={openLinkBtn}
            to={{ pathname: link }}
            target="_blank"
            style={{ display: 'none' }}
          />
        )}
      </InnerWrapper>
    );
  }

  return <NotAuthorizedScreen />;
};

export default HealthAndSafetyTrainingReportForm;
